var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.5V4.75C3 4.33579 3.33579 4 3.75 4H6.5V6H4.5V8.5H3V6.5ZM20.25 4C20.6642 4 21 4.33579 21 4.75V6.5H19.5V8.5H18V6H20.25V4ZM3 17.5V19.25C3 19.6642 3.33579 20 3.75 20H6.5V18H4.5V15.5H3V17.5ZM20.25 20C20.6642 20 21 19.6642 21 19.25V17.5H19.5V15.5H18V18H20.25V20Z",
    fill: "#ffffff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 1.5,
    height: 16,
    rx: 0.5,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 4,
    width: 1.5,
    height: 16,
    rx: 0.5,
    fill: "#ffffff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 1.5,
    height: 16,
    rx: 0.5,
    fill: "#ffffff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 4,
    width: 1.5,
    height: 16,
    rx: 0.5,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeMenu);
export default __webpack_public_path__ + "static/media/barcode-menu.6e9288767c051eb93982b2ec81c283f4.svg";
export { ForwardRef as ReactComponent };